// utils/api.js
// Centralized fetch wrapper that attaches the CSRF token header
// on state-changing requests (POST, PATCH, PUT, DELETE).

function getCsrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)csrf-token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export default async function apiFetch(url, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const safeMethods = ['GET', 'HEAD', 'OPTIONS'];

  const headers = { ...options.headers };

  if (!safeMethods.includes(method)) {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      headers['X-CSRF-Token'] = csrfToken;
    }
  }

  return fetch(url, {
    ...options,
    headers,
    credentials: options.credentials || 'include',
  });
}
